import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./services/I18N/i18nextInit";



const rootElement = document.getElementById("root");
ReactDOM.render(
  <Suspense fallback="...">
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Suspense>,
  rootElement
);
